import s from './RequestCard.module.css';
import { Flex } from '@repo/ui/Flex';
import { Text } from '../Language/Language';
import { Link } from '@tanstack/react-router';
import type { SubmittedRequest } from '../../graphql/query/getOrder';
import { getParams } from '../../utils/searchParams';
import { formatToShort } from '../../utils/dates';

export const RequestCard = ({
  id,
  submitDate,
  items,
  deliveryMethod,
  retailer,
}: SubmittedRequest & { retailer: string | null }) => {
  return (
    <Flex key={id} direction="column" gap="g-32" className={s.card}>
      <Flex direction="column" gap="g-16">
        <Flex direction="row">
          {items.map((item) => (
            <img
              alt={item.name ?? ''}
              className={s.image}
              key={item.id}
              src={item.image?.url ?? ''}
            />
          ))}
        </Flex>

        <Flex
          className={s.details}
          justifyContent="space-between"
          alignItems="center"
          padding="p-24"
        >
          <Flex direction="column">
            <strong>
              <Text
                langKey={`pdx.item_selection.submitted_requests.details.delivery.${deliveryMethod?.toLowerCase()}`}
              />
            </strong>
            {submitDate && (
              <Text
                langKey={`pdx.item_selection.submitted_requests.details.submit_date.${items.length === 1 ? 'one' : 'many'}`}
                replacementTokens={{
                  date: formatToShort(submitDate, getParams()?.locale),
                  item_count: `${items.length}`,
                }}
              />
            )}
          </Flex>
          <Link
            to="/$retailer/submitted-details/$requestId"
            params={{ requestId: id, retailer: retailer ?? 's' }}
            search={(prev) => {
              return { ...prev };
            }}
          >
            <Text
              langKey={'pdx.item_selection.submitted_requests.details.link'}
            />
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
};
